export default {"src":"/_next/static/media/brand-wmf.07be8d86.svg","height":83,"width":80};